import React, { useState } from 'react';
import { Box } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { ContactUs } from '../organisms/ContactUs';
import { FormField } from '../../stateManagement/SettingsContext';
import { Header } from '../organisms';
import { Footer } from '../organisms/Footer';
import { Settings } from '../../interfaces';
import { useAuth } from '../../stateManagement/auth/useAuth';
import { BannerWithSearchBar } from '../organisms/BannerWithSearchBar';

interface ContactUsPagePreviewProps {
  settings: Settings;
  supportedLanguages: { label: string; value: string }[];
  onClickMyTickets: () => void;
  onClickLandingPageButton: () => void;
  contactUsFormData: FormField[];
}
export const ContactUsPagePreview: React.FC<ContactUsPagePreviewProps> = ({
  settings,
  supportedLanguages,
  onClickMyTickets,
  onClickLandingPageButton,
  contactUsFormData,
}) => {
  // const { contactUsFormData } = useSettings();
  const { t }: { t: (key: string, options?: { returnObjects: boolean }) => any } = useTranslation();
  // const translatedContactUsFormData = t('data.contactUsFormData', { returnObjects: true });
  const helperTexts = t('data.helperTexts', { returnObjects: true });
  const [currentLanguage, setCurrentLanguage] = useState('English');
  const { accessToken } = useAuth();

  const changeTheme = () => {};
  const handleLanguageChange = () => {
    setCurrentLanguage('english');
  };
  const translatedData = contactUsFormData;
  // const translatedData: FormField[] = (contactUsFormData ?? []).map(link => {
  //   const translation = translatedContactUsFormData.find(
  //     (i: {
  //       id: string;
  //       question?: string;
  //       description?: string;
  //       placeholder?: string;
  //       options?: FormFieldOptions; // Ensure this type is handled correctly if present
  //     }) => i.id === link.id,
  //   );
  //   return {
  //     ...link,
  //     question: translation?.question ?? link.question,
  //     description: translation?.description ?? link.description,
  //     placeholder: translation?.placeholder ?? link.placeholder,
  //     options: translation?.options ?? link.options,
  //   };
  // });
  const bannerInfo = translatedData.find(item => item.id === '1');
  return (
    <Box backgroundColor={settings?.configs.secondaryBgColor}>
      {/* Header */}
      {settings?.configs?.showHeader && (
        <Header
          showMainHeader={settings?.configs.showMainHeader}
          mainHeaderBgColor={settings?.configs.mainHeaderBgColor}
          mainHeaderTextColor={settings?.configs.mainHeaderTextColor}
          showSubHeader={settings?.configs.showSubHeader}
          subHeaderBgColor={settings?.configs.primaryBgColor}
          subHeaderTextColor={settings?.configs.primaryTextColor}
          showHeaderLogo={settings?.configs.showHeaderLogo}
          logoUrl={settings?.configs.headerlogoUrl}
          gameTitle={settings?.data.gameTitle}
          platforms={settings?.data.platforms}
          supportedLanguages={supportedLanguages}
          currentLanguage={currentLanguage}
          onLanguageChange={handleLanguageChange}
          horizontalPadding={{ base: '1', md: '8vw', lg: '12vw' }} // Responsive padding
          changeTheme={changeTheme}
          onClickMyTickets={onClickMyTickets}
          myTicketsButtonText={
            helperTexts.find((item: Record<string, string>) => 'myTicketsButtonText' in item)
              ?.myTicketsButtonText
          }
          loginButtonText={
            helperTexts.find((item: Record<string, string>) => 'loginButtonText' in item)
              ?.loginButtonText
          }
          logoWidth={settings?.configs?.headerLogoSize}
          onClickLandingPageButton={onClickLandingPageButton}
          secondaryAccentColor={settings.configs.secondaryAccentColor}
          headerTextColors={settings.configs.headerTextColors}
          isPreviewMode
        />
      )}
      <BannerWithSearchBar
        isFullScreen={settings?.configs.isBannerFullScreen}
        px={{
          base: '0vw',
          md: '0vw',
          lg: settings?.configs.isBannerFullScreen ? '0vw' : '7vw',
        }}
        imageSrc={settings?.configs.contactUsLogo}
        altText="Contact Us Banner"
        bannerText={bannerInfo?.question || 'Get in Touch'}
        subText={bannerInfo?.description || ''}
        showSearchBar={false}
        bannerTextColor="white"
        placeholderText=""
        showOverlay={undefined}
        showJaggedBorder={settings?.configs.showJaggedBorder}
        secondaryAccentColor={settings?.configs.secondaryAccentColor}
        placeholderFontSize={{ base: '20px', md: '22px', lg: '24px' }} // Responsive font size
        placeholderFontWeight="bold"
        isPreview
      />
      <Box
        backgroundColor={settings?.configs.secondaryBgColor}
        bgGradient={`linear(to-b, white 80%, ${settings?.configs.tertiaryAccentColor} 100%)`}
      >
        <ContactUs
          accessToken={accessToken}
          FormFields={translatedData}
          createTicketButtonText={
            helperTexts.find((item: Record<string, string>) => 'createTicketButtonText' in item)
              ?.createTicketButtonText
          }
          liveChatButtonText={
            helperTexts.find((item: Record<string, string>) => 'liveChatButtonText' in item)
              ?.liveChatButtonText
          }
          secondaryAccentColor={settings?.configs.secondaryAccentColor}
          showRocks={settings?.configs.showRocks}
          showJaggedBorder={settings?.configs.showJaggedBorder}
          footerBgColor={settings?.configs.footerBackgroundColor}
          rocksImageUrl={settings?.configs.rocksImageUrl}
          contactUsDisclaimerToastTextColor={settings?.configs.contactUsDisclaimerToastTextColor}
          contactUsDisclaimerToastBgColor={settings?.configs.contactUsDisclaimerToastBgColor}
          contactUsDisclaimerToastText={settings?.data.contactUsDisclaimerToastText}
          isPreviewMode
        />
      </Box>
      <Footer
        showFooterLogo={settings?.configs?.showFooterLogo}
        showFooterLinks={settings?.configs?.showFooterLinks}
        links={settings?.data?.footerLinks}
        imageSrc={settings?.configs?.footerLogoUrl}
        logoWidth={settings?.configs?.footerLogoSize}
        footerNote={settings?.data?.footerNote}
        footerBgColor={settings?.configs?.footerBackgroundColor}
        footerTextColor={settings?.configs?.footerTextColor}
        openFooterLinkInNewTab={settings?.configs?.openFooterLinkInNewTab}
      />
    </Box>
  );
};
